export default __webpack_public_path__ + "static/media/Directory.d9a3ac9f.svg";